export const GET_AUDIT= "GET_AUDIT";
export const GET_LIKES = "GET_LIKES";
export const GET_AUDIENCE = "GET_AUDIENCE";
export const GET_AGE = "GET_AGE";
export const GET_THEMATIC = "GET_THEMATIC";
export const SET_THEMATIC = "SET_THEMATIC";
export const CHANGE_AGE = "CHANGE_AGE";
export const SET_AGE = "SET_AGE";
export const GET_IN_AGE = "GET_IN_AGE";
export const SET_IN_AGE = "SET_IN_AGE";
export const GET_SUMMARY = "GET_SUMMARY";
export const SET_SUMMARY = "SET_SUMMARY";
export const GET_SEX = "GET_SEX";
export const SET_SEX = "SET_SEX";
export const SET_LIKES= "SET_LIKES";
export const SET_AUDIENCE = "SET_AUDIENCE";
export const SET_AUDIT_PENDING = "SET_AUDIT_PENDING";
export const SET_AUDIT_PERIOD = "SET_AUDIT_PERIOD";
export const SET_AUDIT_PERIOD_NAME = "SET_AUDIT_PERIOD_NAME";
export const SET_AUDIT_GLOBAL_PERIOD = "SET_AUDIT_GLOBAL_PERIOD";
export const UPDATE_AUDIT_CHART = "UPDATE_AUDIT_CHART";
